import { Flex, Skeleton, Table } from "@fluentui/react-northstar";
import React from "react";
import { TableCellStyles } from "../ajustementSolde/HistoryList";

const SkeletonListAjustments = () => {
    return (
        <>
            <Skeleton animation="pulse">
                {new Array(10).fill("").map((row, i) => {
                    return (
                        <Table aria-label="table">
                            <Table.Row>
                                <Table.Cell
                                    content={
                                        <Skeleton.Line
                                            width="66px"
                                            height="20px"
                                        />
                                    }
                                />
                                <Table.Cell
                                    content={
                                        <Flex gap="gap.small" vAlign="center">
                                            <Skeleton.Avatar />
                                            <Skeleton.Line
                                                width="90px"
                                                height="20px"
                                            />
                                        </Flex>
                                    }
                                />
                                <Table.Cell
                                    content={
                                        <Skeleton.Line
                                            width="90px"
                                            height="20px"
                                        />
                                    }
                                />
                                <Table.Cell
                                    content={
                                        <Skeleton.Line
                                            width="90px"
                                            height="20px"
                                        />
                                    }
                                />
                                <Table.Cell
                                    content={
                                        <Skeleton.Line
                                            width="50px"
                                            height="30px"
                                        />
                                    }
                                />
                                <Table.Cell
                                    content={
                                        <Skeleton.Line
                                            width="90px"
                                            height="20px"
                                        />
                                    }
                                />
                                <Table.Cell
                                    content={
                                        <Skeleton.Line
                                            width="20px"
                                            height="20px"
                                        />
                                    }
                                    styles={TableCellStyles.comment}
                                />
                            </Table.Row>
                        </Table>
                    );
                })}
            </Skeleton>
        </>
    );
};

export default SkeletonListAjustments;
